import { useGetIdentity } from '@pankod/refine-core'

import { Row, Col, AntdLayout, Card, Form, Button, message, useModalForm, Avatar, Typography, Space, Divider, Tag } from '@pankod/refine-antd'
import React, { useState, useEffect } from 'react'
import { UserEdit } from 'pages/profile/edit'
import { resetPassword, getUsersById } from 'users'
import { UserOutlined, MailOutlined, LockOutlined, SafetyCertificateOutlined, EditOutlined, ArrowLeftOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

export const UpdateProfilePage: React.FC = () => {
  const [form] = Form.useForm()
  const { data: user } = useGetIdentity()
  const [refresh, setRefresh] = useState(false)
  const [userList, setUserList] = useState([] as any[])
  const [userRecord, setUserRecord] = useState()
  const refreshData = () => {
    getUsers()
    setRefresh(!refresh)
  }

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: editClose,
  } = useModalForm({
    // resource: "users",
    action: 'edit',
  })

  const getUsers = async () => {
    getUsersById(user?.id).then((response: any) => {
      setUserList(response.users)
      setUserRecord(response.users[0])
    })
  }

  useEffect(() => {
    getUsers()
  }, [user?.id])

  const success = (msg: string, type: string) => {
    form.resetFields()
    if (type === 'success') {
      message.success(msg)
    } else message.error(msg)
  }

  const changeclick = (data: any) => {
    let values = { email: data }
    resetPassword(values).then(response => {
      if (response === 'OK') {
        success('Reset Link has been sent to your Email ID.', 'success')
      } else {
        success(response, 'danger')
      }
    })
  }

  return (
    <>
      <AntdLayout style={{ minHeight: '80vh', padding: '24px' }}>
        <Row justify="center" style={{ width: '100%' }}>
            {/* Responsive Column: Wide on large screens, Full on small */}
            <Col xs={24} sm={24} md={22} lg={18} xl={16}>
                <Card
                    bordered={false}
                    style={{
                        borderRadius: '16px',
                        boxShadow: '0 20px 27px 0 rgb(0 0 0 / 5%)',
                        overflow: 'hidden',
                        marginBottom: 24
                    }}
                    bodyStyle={{ padding: 0 }}
                >
                    {/* Header Banner - Project Theme Gradient */}
                    <div style={{
                        height: '180px',
                        background: 'linear-gradient(310deg, #7928ca 0%, #6659ff 100%)',
                        position: 'relative'
                    }}>
                        <Button
                            ghost
                            icon={<ArrowLeftOutlined />}
                            onClick={() => window.history.back()}
                            style={{ position: 'absolute', top: 24, left: 24, border: 'none', color: '#fff', fontSize: '16px' }}
                        >
                            Back
                        </Button>
                    </div>

                    <div style={{ padding: '0 40px 40px 40px', marginTop: '-75px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}> 
                            {/* Flex column mostly for mobile, but overlaps work via negative margins/absolute */}
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '20px' }}>
                                <div style={{ position: 'relative' }}>
                                    <Avatar
                                        size={150}
                                        icon={<UserOutlined />}
                                        style={{
                                            backgroundColor: '#fff',
                                            color: '#6659FF',
                                            border: '6px solid #fff',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                        }}
                                    />
                                </div>
                                <div style={{ marginBottom: 10 }}>
                                  <Button
                                      type="primary"
                                      shape="round"
                                      icon={<EditOutlined />}
                                      size="large"
                                      onClick={() => editShow()}
                                      style={{ 
                                          paddingLeft: 24, 
                                          paddingRight: 24,
                                          boxShadow: '0 4px 14px rgba(102, 89, 255, 0.3)',
                                          backgroundColor: '#6659FF',
                                          borderColor: '#6659FF'
                                      }}
                                  >
                                      Edit Profile
                                  </Button>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: 20, marginBottom: 32 }}>
                            <Title level={2} style={{ marginBottom: 4, fontWeight: 700, color: '#303C4C' }}>
                                {userList[0]?.displayName || '...'}
                            </Title>
                            <Space wrap size="middle" align="center">
                                <Text type="secondary" style={{ fontSize: 16 }}>{userList[0]?.email}</Text>
                                <Tag color="purple" style={{ borderRadius: 12, padding: '2px 10px', fontSize: 12, fontWeight: 600 }}>
                                    {userList[0]?.defaultRole || 'USER'}
                                </Tag>
                            </Space>
                        </div>

                        <Divider style={{ borderColor: '#f0f0f0' }} />

                        <div style={{ marginTop: 32 }}>
                            <Text strong style={{ color: '#b0b0b0', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '1px', display: 'block', marginBottom: 24 }}>
                                Account Information
                            </Text>

                            <Row gutter={[48, 24]}>
                                <Col xs={24} md={12}>
                                    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 8 }}>
                                        <Col flex="50px">
                                            <div style={{ height: 48, width: 48, borderRadius: '50%', background: 'rgba(102, 89, 255, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <UserOutlined style={{ fontSize: '20px', color: '#6659FF' }} />
                                            </div>
                                        </Col>
                                        <Col flex="auto">
                                            <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}>Username</Text>
                                            <Text style={{ fontSize: '16px', fontWeight: 500, color: '#303C4C' }}>{userList[0]?.displayName || '-'}</Text>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={24} md={12}>
                                    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 8 }}>
                                        <Col flex="50px">
                                            <div style={{ height: 48, width: 48, borderRadius: '50%', background: 'rgba(102, 89, 255, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <MailOutlined style={{ fontSize: '20px', color: '#6659FF' }} />
                                            </div>
                                        </Col>
                                        <Col flex="auto">
                                            <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}>Email Address</Text>
                                            <Text style={{ fontSize: '16px', fontWeight: 500, color: '#303C4C' }}>{userList[0]?.email || '-'}</Text>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={24} md={12}>
                                    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 8 }}>
                                        <Col flex="50px">
                                            <div style={{ height: 48, width: 48, borderRadius: '50%', background: 'rgba(102, 89, 255, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <SafetyCertificateOutlined style={{ fontSize: '20px', color: '#6659FF' }} />
                                            </div>
                                        </Col>
                                        <Col flex="auto">
                                            <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}>Assigned Role</Text>
                                            <Text style={{ fontSize: '16px', fontWeight: 500, color: '#303C4C' }}>{userList[0]?.defaultRole || '-'}</Text>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={24} md={12}>
                                    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 8 }}>
                                        <Col flex="50px">
                                            <div style={{ height: 48, width: 48, borderRadius: '50%', background: 'rgba(102, 89, 255, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <LockOutlined style={{ fontSize: '20px', color: '#6659FF' }} />
                                            </div>
                                        </Col>
                                        <Col flex="auto">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                <div>
                                                    <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}>Security</Text>
                                                    <Text style={{ fontSize: '16px', fontWeight: 500, color: '#303C4C' }}>Password</Text>
                                                </div>
                                                <Button 
                                                    size="small" 
                                                    type="default"
                                                    onClick={() => changeclick(user.email)}
                                                    style={{ borderRadius: 6, fontSize: 13, borderColor: '#6659FF', color: '#6659FF' }}
                                                >
                                                    Reset Password
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Card>
            </Col>
        </Row>
      </AntdLayout>
      <UserEdit modalProps={editModalProps} formProps={editFormProps} close={editClose} record={userRecord} refreshData={refreshData} />
    </>
  )
}
